/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Role_FirstInputs */

const en_endpoint_role_first = /** @type {(inputs: Endpoint_Role_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serves first`)
};

const zh_hans1_endpoint_role_first = /** @type {(inputs: Endpoint_Role_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`优先响应`)
};

const pt_br2_endpoint_role_first = /** @type {(inputs: Endpoint_Role_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atende primeiro`)
};

const es_endpoint_role_first = /** @type {(inputs: Endpoint_Role_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responde primero`)
};

const fr_endpoint_role_first = /** @type {(inputs: Endpoint_Role_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répond en premier`)
};

const de_endpoint_role_first = /** @type {(inputs: Endpoint_Role_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedient zuerst`)
};

const ru_endpoint_role_first = /** @type {(inputs: Endpoint_Role_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обслуживает первым`)
};

const it_endpoint_role_first = /** @type {(inputs: Endpoint_Role_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serve per primo`)
};

/**
* | output |
* | --- |
* | "Serves first" |
*
* @param {Endpoint_Role_FirstInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_role_first = /** @type {((inputs?: Endpoint_Role_FirstInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Role_FirstInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_role_first(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_role_first(inputs)
	if (locale === "es") return es_endpoint_role_first(inputs)
	if (locale === "fr") return fr_endpoint_role_first(inputs)
	if (locale === "de") return de_endpoint_role_first(inputs)
	if (locale === "ru") return ru_endpoint_role_first(inputs)
	if (locale === "it") return it_endpoint_role_first(inputs)
	return en_endpoint_role_first(inputs)
});